module.exports = __webpack_public_path__ + "static/scientific_papers-f53ef617aad60e054b97b917247d763a.png";